import ProductTableHeader from './ProductTableHeader';

interface ProductTableSkeletonProps {
  rows?: number;
  showAction?: boolean;
}

const ProductTableSkeleton = ({
  rows = 8,
  showAction = false,
}: ProductTableSkeletonProps) => {
  return (
    <div
      className="
        overflow-hidden

        rounded-xl
        border

        border-stroke

        bg-whiten

        shadow-default

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <ProductTableHeader showAction={showAction} />

      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="
            flex
            items-center
            gap-4

            border-b
            border-stroke

            bg-whiten

            px-4
            py-4

            last:border-b-0

            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          {/* Imagen */}

          <div
            className="
              h-14
              w-14

              shrink-0

              animate-pulse

              rounded-xl

              bg-slate-200

              dark:bg-meta-4
            "
          />

          {/* Producto */}

          <div className="flex-1 space-y-2">
            <div
              className="
                h-4
                w-56

                animate-pulse

                rounded

                bg-slate-200

                dark:bg-meta-4
              "
            />

            <div
              className="
                h-3
                w-24

                animate-pulse

                rounded

                bg-slate-200

                dark:bg-meta-4
              "
            />
          </div>

          {/* Precio */}

          <div
            className="
              h-5
              w-[90px]

              shrink-0

              animate-pulse

              rounded

              bg-slate-200

              dark:bg-meta-4
            "
          />

          {/* Stock */}

          <div
            className="
              h-8
              w-[90px]

              shrink-0

              animate-pulse

              rounded-lg

              bg-slate-200

              dark:bg-meta-4
            "
          />

          {showAction && (
            <div
              className="
                h-10
                w-[120px]

                shrink-0

                animate-pulse

                rounded-xl

                bg-slate-200

                dark:bg-meta-4
              "
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductTableSkeleton;